import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LawFirmEmployee, LawFirmEmployeeType } from '@models/lawFirms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { LawyerSearchState } from '@state/algolia-search/lawyer-search';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { ICON } from '@core/util/icon';
import { LawyerSearchDispatch } from '@state/algolia-search/lawyer-search/dispatch';
import {
	CreateLawFirmEmployeeComponent,
	CreateOrUpdateLawFirmEmployeeModel,
} from '../create-employee/create-employee.component';
import { Employee } from '@models/company';
import { LawFirm } from '@models/lawFirms';
import { TestHooks } from './clerk.hooks';

@UntilDestroy()
@Component({
	selector: 'app-clerk',
	templateUrl: './clerk.component.html',
	styleUrls: ['./clerk.component.scss'],
	standalone: false,
})
export class ClerkComponent {
	testHooks = TestHooks;
	public _clerkName = '';
	public _clerkFirstName = '';
	public _clerkLastName = '';
	public ICON = ICON;
	public _focus = false;
	public hoverShadow = true;

	@ViewSelectSnapshot(LawyerSearchState.getList) searchResult;

	@Input() lawFirm: LawFirm;
	@Output() onSelectClerk = new EventEmitter<Employee>();
	@Output() onCreateOrUpdateClerk = new EventEmitter<Employee>();
	@Output() onRemoveClerk = new EventEmitter();
	@Output() onFocus = new EventEmitter();

	constructor(
		private dialog: MatDialog,
		private lawyerSearchDispatch: LawyerSearchDispatch,
	) {}

	_onFocus() {
		this.onFocus.emit();
		this._focus = true;
	}

	setClerk(ev: DropdownResult<LawFirmEmployee>) {
		if (ev.group === 1) {
			this.onSelectClerk.emit(ev.result);
		}
	}

	removeClerk() {
		this.onRemoveClerk.emit();
		this._clerkName = '';
	}

	createOrUpdateClerk() {
		const lawFirmEmployeeModel: CreateOrUpdateLawFirmEmployeeModel = {
			name: this._clerkName,
			firstName: this._clerkFirstName,
			lastName: this._clerkLastName,
			role: LawFirmEmployeeType.CLERK,
			lawFirm: this.lawFirm,
		};
		const dialogRef = this.dialog.open(CreateLawFirmEmployeeComponent, {
			width: '800px',
			height: '500px',
			data: lawFirmEmployeeModel,
		});
		dialogRef
			.afterClosed()
			.pipe(untilDestroyed(this))
			.subscribe((result) => {
				if (result) {
					this.onCreateOrUpdateClerk.emit({
						...result,
						role: LawFirmEmployeeType.CLERK,
					});
				}
			});
	}

	searchClerk(value) {
		this.lawyerSearchDispatch.Search({
			searchValue: value,
			lawFirmId: this.lawFirm.id,
			cardId: this.lawFirm.leap?.cardId,
			role: LawFirmEmployeeType.CLERK,
		});
	}

	clerkDropdownOptionSelect(event) {
		switch (event.result.name) {
			case 'Edit':
				this._clerkFirstName = this.lawFirm.clerk.firstName;
				this._clerkLastName = this.lawFirm.clerk.lastName;
				this.createOrUpdateClerk();
				break;
			case 'Remove':
				this.removeClerk();
				break;
		}
	}
}
